import { useMediaQuery, DialogTitle, DialogContent, DialogActions, Grid2 as Grid, Dialog } from "@mui/material";
import { LargeActionButton } from "../Common/LargeActionButton";
import modalSize from "../../util/modalSizeEnum";
import { useStyles } from "./Modal.styles";
import { Alert, AlertTitle, AlertColor } from "@mui/material"; 
import { primaryModalActionStyles } from "../Common/modalActionStyles";
import { MOBILE_MODAL_MEDIA_QUERY } from "./Modal.constants";

interface ModalHistoryProps {
	title?: string;
	alertType?: string;
	primaryButtonName: string;
	onPrimaryButtonClick: () => void;
	isOpen: boolean;
	onClose?: () => void;
	children?: React.ReactNode;
	size?: string;
}

export const ModalHistory = (props: ModalHistoryProps) => {
	const classes = useStyles();
	const {
		isOpen,
		onClose: onCancel,
		title,
		children,
		primaryButtonName,
		onPrimaryButtonClick,
		alertType,
		size,
	} = props;
	const mobileView = useMediaQuery(MOBILE_MODAL_MEDIA_QUERY);
	const getAlertType = (alertType): AlertColor => {
		return alertType as AlertColor;
	};

	return (
		<Dialog
			open={isOpen}
			onClose={onCancel}
			className={size === modalSize.MEDIUM ? classes.modalHistoryMediumSize : classes.fullScreen}
			fullScreen={mobileView}
		>
			<DialogTitle>
				<Alert
					severity={getAlertType(alertType)}
					variant="outlined"
					className={classes.modalHistoryAlert}
					onClose={onCancel}
				>
					{title && <AlertTitle className={classes.alertTitle}>{title}</AlertTitle>}
				</Alert>
			</DialogTitle>
			<DialogContent className={classes.modalHistoryDialogContent}>{children}</DialogContent>
			<DialogActions className={classes.modalHistoryDialogActions}>
				<Grid container direction="column" spacing={mobileView ? 1 : 1} sx={{ width: '100%' }}>
					<Grid size={12} container justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
						<LargeActionButton
							onClick={onPrimaryButtonClick}
							sx={primaryModalActionStyles}
							children={primaryButtonName}
						/>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
};
